"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizationAuthSuiteService = exports.AuthorizationAuthSuiteService = void 0;
var authorization_auth_suite_service_1 = require("./authorization-auth-suite.service");
Object.defineProperty(exports, "AuthorizationAuthSuiteService", { enumerable: true, get: function () { return authorization_auth_suite_service_1.AuthorizationAuthSuiteService; } });
Object.defineProperty(exports, "authorizationAuthSuiteService", { enumerable: true, get: function () { return authorization_auth_suite_service_1.authorizationAuthSuiteService; } });
